var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10283",
    "data-name": "Group 10283",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2351",
    "data-name": "Rectangle 2351",
    width: 22,
    height: 28,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27602",
    "data-name": "Path 27602",
    d: "M21.943,2.314a1.4,1.4,0,0,0-1.177-.285A11.256,11.256,0,0,1,12.028.253a1.384,1.384,0,0,0-1.595,0A11.256,11.256,0,0,1,1.7,2.029,1.4,1.4,0,0,0,0,3.41V13.866A12.627,12.627,0,0,0,5.294,24.154l5.125,3.656a1.407,1.407,0,0,0,1.625,0l5.125-3.656a12.627,12.627,0,0,0,5.294-10.288V3.41a1.4,1.4,0,0,0-.518-1.1M19.654,13.866a9.818,9.818,0,0,1-4.116,8l-4.307,3.077L6.924,21.867a9.818,9.818,0,0,1-4.116-8V5.02a14.016,14.016,0,0,0,8.423-1.952A14.016,14.016,0,0,0,19.654,5.02Zm-6.259-3.218-3.779,3.8L8.365,13.18a1.409,1.409,0,1,0-1.99,2L8.62,17.421a1.421,1.421,0,0,0,1,.416,1.448,1.448,0,0,0,1-.416l4.826-4.79a1.411,1.411,0,1,0-2-2Z",
    transform: "translate(0 0)",
    fill: "#161615"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyIcon);
export default __webpack_public_path__ + "static/media/warranty_icon.b42da44400a0a0bc2f1195afb9c7a0de.svg";
export { ForwardRef as ReactComponent };